'use strict';

// Dependencies
let SoaModel = require('bunsen/models/SoaModel');
let SoaCollection = require('bunsen/collections/SoaCollection');
let _ = require('underscore');
let assert = require('bunsen/helpers/assert');
let DataListModel;

/**
 * @class DataListModel
 * @extends SoaModel
 */

DataListModel = module.exports = SoaModel.extend({
    initialize: function(options) {
        assert(options.apiType, 'You must include an apiType for a data list.');
        options.dataList = options.dataList || new SoaCollection([]);
        DataListModel.__super__.initialize.call(this, options);
    }
});



// WEBPACK FOOTER //
// ./~/bunsen/models/DataListModel.es.js